import { useEffect, useRef } from 'react';

const features = [
  { icon: 'ri-shield-check-line', label: 'Güvenli Taşımacılık' },
  { icon: 'ri-time-line', label: 'Zamanında Teslimat' },
  { icon: 'ri-global-line', label: 'Uluslararası Ağ' },
  { icon: 'ri-customer-service-2-line', label: '7/24 Destek' },
];

export default function About() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-10');
          }
        });
      },
      { threshold: 0.15 }
    );

    const children = sectionRef.current?.querySelectorAll('.animate-on-scroll');
    children?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="hakkimizda" className="py-24 bg-white" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          {/* Left: Text */}
          <div className="w-full lg:w-5/12 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700">
            <span className="text-orange-500 text-sm font-bold uppercase tracking-widest mb-4 block">
              Hakkımızda
            </span>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Sınır Tanımayan<br />
              <span className="text-orange-500">Lojistik</span><br />
              Güvenle Taşıyoruz
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Global79 Lojistik olarak, Kilis merkezli firmamızdan yurtiçi ve yurtdışı güzergahlarda
              düzenli ve güvenilir taşımacılık hizmeti sunuyoruz. Türkiye, Suriye, Azerbaycan, Irak,
              İran, Gürcistan, Ermenistan ve Rusya&apos;ya uzanan geniş ağımızla müşterilerimizin yüklerini
              en hızlı ve güvenli şekilde teslim ediyoruz.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-10">
              Deneyimli ekibimiz ve modern araç filomuzla, parsiyel ve komple yük taşımacılığında
              sektörün en güvenilir ismi olmayı hedefliyoruz. Her yükü kendi yükümüz gibi taşıyoruz.
            </p>

            {/* Features */}
            <div className="grid grid-cols-2 gap-4">
              {features.map((f) => (
                <div key={f.label} className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-50 rounded-lg">
                    <i className={`${f.icon} text-orange-500 text-lg`} />
                  </div>
                  <span className="text-gray-700 font-semibold text-sm">{f.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Images */}
          <div className="w-full lg:w-7/12 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-200">
            <div className="flex gap-4 h-[480px]">
              <div className="w-[45%] rounded-2xl overflow-hidden">
                <img
                  src="/assets/images/about-warehouse.png"
                  alt="Lojistik Depo"
                  loading="eager"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-[55%] flex flex-col gap-4">
                <div className="flex-1 rounded-2xl overflow-hidden">
                  <img
                    src="/assets/images/about-truck.png"
                    alt="Kamyon Taşımacılığı"
                    loading="eager"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 rounded-2xl overflow-hidden bg-orange-500 flex flex-col items-center justify-center p-6 text-center">
                  <div className="text-5xl font-extrabold text-white mb-2">15+</div>
                  <div className="text-white/90 font-semibold text-lg">Yıllık Tecrübe</div>
                  <div className="text-white/70 text-sm mt-2">Uluslararası lojistikte güvenilir çözüm ortağınız</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
